import React, { useState } from 'react';
import '../styles/ChatWidget.css'; 

const urlDoWorker = 'https://tbsoftwares-webhook.developers-tbsoftwares.workers.dev';

const ChatWidget: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [email,setEmail] = useState('');
  const [name,setName] = useState('');
  const [message,setMessage] = useState('');
  const [erros, setErros] = useState({ name: '', email: '', message: '' });
  const [sucessMessage, setSucessMessage] = useState('');
  const [backgroundColor, setBackgroundColor] = useState('rgb(250, 30, 30)')

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const handleSendMessage = () => {
    if (isEntrysValid()) handleSucess();
  };

  const isEntrysValid = () =>{
    const newErros = {
        name: name === ''? 'Preencha o campo acima': '',
        email: isEmailsFormatValid(),
        message: message === ''? 'Preencha o campo acima': '',
      };
    setErros(newErros);
    console.log(newErros)
    if (!newErros.name && !newErros.email && !newErros.message)
        return true;
    else 
        return false;
  };

  const handleSucess = async () => {
    if (await sendMessageToAPI()) showSucessMessage();
    else showFailToSendMessage(); 
  }

  const showSucessMessage = () => {
    setSucessMessage('Mensagem enviada com sucesso!');
    setName('');
    setEmail('');
    setMessage('');
    setErros({ name: '', email: '', message: '' });
    setBackgroundColor('rgb(61, 161, 61)');
    setTimeout(() => {
      setSucessMessage('');
    }, 5000);
  }

  const showFailToSendMessage = () => {
    setSucessMessage('Sistema da empresa inacessível.');
    setBackgroundColor('rgb(250, 30, 30)')
    setTimeout(() => {
        setSucessMessage('');
    }, 5000);
  }

  const sendMessageToAPI = async () => {
    const fullMessage = {name:name, email:email, message:message};
    console.log(fullMessage)
    try{
        const response = await fetch(urlDoWorker, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify(fullMessage),
        });
        if (!response.ok){
          return false;
        } 
    } catch (error) {
      console.log(error)
      return false;
    }
    return true;
  };

  const isEmailsFormatValid = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email === '') return "Preencha o campo acima"
    else if(!emailRegex.test(email)) return "Preencha o campo acima corretamente"
    else return ''
  };

  return (
    <div className={`chat-widget${isOpen ? '-open' : ''}`}>
      <div className="open-button" onClick={toggleChat}>
          <span role="img" aria-label="chat">💬</span> Falar
      </div>
      {isOpen && (
        <div className="chat-body">
          <div className="input-area">
            {sucessMessage && (
                <div className="sucess-message-div" style={{backgroundColor:backgroundColor}}>
                    {sucessMessage}
                </div>
            )}
            <input
              type="text"
              placeholder="Nome"
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
            {erros.name && <p className="erro-mensagem">{erros.name}</p>}
            <input
              type="text"
              placeholder="e-mail"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
            {erros.email && <p className="erro-mensagem">{erros.email}</p>}
            <textarea
                rows={5}
                cols={40}
                value={message} // Se você estiver usando um componente controlado
                onChange={(event) => setMessage(event.target.value)} // Para componentes controlados
                placeholder="Deixe sua mensagem aqui..."
                />
            {erros.message && <p className="erro-mensagem">{erros.message}</p>}
            <button onClick={handleSendMessage}>Enviar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatWidget;